import { render, staticRenderFns } from "./kpi-index.vue?vue&type=template&id=4fdde7fe&scoped=true"
import script from "./kpi-index.vue?vue&type=script&lang=js"
export * from "./kpi-index.vue?vue&type=script&lang=js"
import style0 from "./kpi-index.vue?vue&type=style&index=0&id=4fdde7fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdde7fe",
  null
  
)

export default component.exports